import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";

import { persistor } from "index";
import { LOGOUT } from "store/reducers/auth";
import { deleteUser } from "store/reducers/userSlice";
  
const LogoutProcess = () => {
    console.log('====================== LogoutProcess =====================')
    const dispatch = useDispatch();
    const navigate = useNavigate();
    
    const logout = async () => {
        dispatch(LOGOUT());
        dispatch(deleteUser());
    }

    //초기화 하는 함수
    const purge = async () => {
        await persistor.purge();
        window.location.replace('/auth/login');
    }
    
    const onIdle = async() => {
        console.log('Idle');
        setTimeout(async() => await purge(), 200)
    }

    useEffect(() => {
        onIdle()
    })

}

export default LogoutProcess;